module.exports = __webpack_public_path__ + "static/media/7.cb00d1b2.wav";